export class ServicePartner {
	Id!: string;
	Name!: string;
	TimeZoneName!: string;
	ContactEmail!: string;
	AssociatedBusinessPartnerIds!: string[];
	Active!: boolean;
}
